import { QRCodeSVG } from "qrcode.react";
import Barcode from "react-barcode";

const Field = ({ k, v, size = "12pt", mono = false }) => (
  <div style={{ minWidth: 0 }}>
    <div className="lbl">{k}</div>
    <div className={`val${mono ? " font-mono-data" : ""}`} style={{ fontSize: size }}>
      {v || "—"}
    </div>
  </div>
);

const KIND_WORD = {
  slab_piece: "SLAB PIECE",
  slab: "SLAB",
  remnant: "REMNANT",
  sink: "SINK",
};

// 4 x 6 in hold label for a slab piece / slab / remnant / sink held for a project.
export const SlabHoldLabel = ({ hold: h, context = {}, forwardRef }) => {
  const code = h.slab_code || (h.label || "").split(" · ")[0] || "";
  const size =
    h.length_in && h.width_in ? `${h.length_in}" × ${h.width_in}"` : "";
  const url =
    context.url ||
    (context.project_id
      ? `${window.location.origin}/admin/projects/${context.project_id}`
      : h.ref_id
        ? `${window.location.origin}/admin/inventory/slabs/${h.ref_id}`
        : window.location.origin);
  const serialClean =
    h.serial && !String(h.serial).toLowerCase().includes("on hand") ? h.serial : "";
  const barcodeValue = serialClean || code || h.bundle || "";

  return (
    <div className="label-4x6 print-label" ref={forwardRef} data-testid="slab-hold-label-sheet">
      {context.logoUrl ? (
        <img
          src={context.logoUrl}
          alt=""
          className="print-fixed print-fixed-logo"
          style={{ height: "0.4in", objectFit: "contain", marginBottom: "0.05in" }}
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
          data-testid="slab-hold-label-logo"
        />
      ) : (
        <div
          style={{
            fontSize: "12pt",
            fontWeight: 800,
            letterSpacing: "0.14em",
            marginBottom: "0.04in",
          }}
        >
          BRIONI GRANITE
        </div>
      )}
      <div className="lbl-head">
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: "8pt", fontWeight: 700, letterSpacing: "0.18em" }}>
            MATERIAL HOLD
          </div>
          <div style={{ fontSize: "20pt", fontWeight: 700, lineHeight: 1.05 }}>
            {h.color || code || "Stone"}
          </div>
          {h.material ? (
            <div style={{ fontSize: "11pt", fontWeight: 600 }}>{h.material}</div>
          ) : null}
        </div>
        <div style={{ textAlign: "right", fontSize: "8pt", fontWeight: 700, flexShrink: 0 }}>
          <div style={{ border: "2px solid #000", padding: "2px 6px" }}>
            {KIND_WORD[h.kind] || "HOLD"}
          </div>
          {code ? (
            <div className="font-mono-data" style={{ marginTop: 3 }}>
              {code}
            </div>
          ) : null}
        </div>
      </div>

      <div
        data-testid="slab-hold-label-reserved"
        style={{
          margin: "0.08in 0",
          border: "2px solid #000",
          padding: "3px 6px",
          fontSize: "11pt",
          fontWeight: 800,
          textTransform: "uppercase",
          letterSpacing: "0.03em",
        }}
      >
        {"\u{1F512} "}
        RESERVED — DO NOT SELL
      </div>

      <div className="lbl-body">
        <div className="lbl-grid">
          <Field k="Customer" v={context.customer} />
          <Field k="Project" v={[context.code, context.title].filter(Boolean).join(" · ")} />
          <Field k="Size" v={size} mono />
          <Field k="Thickness" v={h.thickness} />
        </div>
        <div className="lbl-grid">
          <Field k="Quote #" v={context.quote_code || h.quote_code || h.held_for} mono />
          <Field k="Held on" v={(context.held_at || h.at || "").slice(0, 10)} mono />
          <Field k="Held by" v={(context.held_by || h.by || "").replace("system:accept", "quote accepted")} />
          {context.install_date ? <Field k="Install" v={context.install_date} mono /> : null}
        </div>
        {h.serial || h.bundle ? (
          <div className="lbl-grid">
            {h.serial ? <Field k="Serial / piece" v={h.serial} mono /> : null}
            {h.bundle ? <Field k="Bundle" v={h.bundle} mono /> : null}
          </div>
        ) : null}
        {h.sqft ? <Field k="Held sq ft" v={`${h.sqft} sf`} mono /> : null}
        <Field k="Rack / location" v={h.location} />
        {barcodeValue ? (
          <div
            data-testid="slab-hold-label-barcode"
            style={{ marginTop: "0.06in", textAlign: "center" }}
          >
            <Barcode
              value={barcodeValue}
              format="CODE128"
              renderer="svg"
              width={1.5}
              height={34}
              fontSize={9}
              margin={0}
              background="#ffffff"
              lineColor="#000000"
            />
          </div>
        ) : null}
      </div>

      <div className="lbl-foot">
        <div style={{ fontSize: "7pt", color: "#333", maxWidth: "2.3in" }}>
          {context.code ? (
            <div className="font-mono-data" style={{ fontSize: "8pt", fontWeight: 700 }}>
              {context.code}
            </div>
          ) : null}
          {context.address || ""}
          <div className="font-mono-data" style={{ fontSize: "7.5pt", fontWeight: 700 }}>
            {context.project_id ? "Scan to open the project" : "Scan for the slab record"}
          </div>
        </div>
        <QRCodeSVG value={url} size={78} level="M" bgColor="#ffffff" fgColor="#000000" />
      </div>
    </div>
  );
};
